module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tjw6L7/tc-custom/9781488087028.jpg?1704273852707",
      "alt": "This image is the cover for the book Convenient Christmas Brides"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Convenient Christmas Brides\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Christmas festivities come with the promise of wedding bells in this anthology of three charming Regency romance novellas!")]), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("Convenient Christmas Brides")]), _vm._v(", the holiday arrangements include marriage proposals that may just bring the gift of true love. In "), _c('i', [_vm._v("The Captain’s Christmas Journey")]), _vm._v(" by Carla Kelly, Captain Everard escorts Verity to her governess job—and for propriety’s sake that means a convenient engagement! In Louise Allen’s "), _c('i', [_vm._v("The Viscount’s Yuletide Betrothal")]), _vm._v(", Eleanor advertises for a “suitable” gentleman to pose as her betrothed over Christmas. And in Laurie Benson’s novella, "), _c('i', [_vm._v("Juliet Sommersby’s One Night Under the Mistletoe")]), _vm._v(" leads to a marriage of convenience with handsome former love Lord Montague . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carla Kelly, Louise Allen, Laurie Benson\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0